import Client from '../clients/model'
import Model from '../../model'

export default class User extends Model {
    resource()
    {
        return 'users'
    }

    clients () {
        return this.hasMany(Client)
    }

    searchedUsers () {
        let endpoint = `${this.baseURL()}/searched-users`

        return this.request({
            method: 'POST',
            url: endpoint,
            data: {user_id: this.getPrimaryKey()}
        }).then(response => {
            let self = {...this, ...response.data.data}

            return self
        })
    }

    updateAvatar(formData) {
        let endpoint = `${this.baseURL()}/${this.resource()}/${this.id}/avatar`

        return this.request({
            method: 'POST',
            url: endpoint,
            data: formData,
        }).then(response => {
            return response.data.data
        })
    }
}
